__webpack_require__.p = "https://btc.dev3.glprotocol.com/";